import datapoints from './datapoints';
import markItemsAsPinnedService from '../services/markItemsAsPinnedService';
import markItemsAsPinnedStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsPinnedStoreUpdate';
import { getRowIdsFromRowKeys, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
/**
 * Pin or unpin items
 * @param rowKeys the row keys
 * @param tableView that the pinned/unpinned items are in
 * @param shouldMarkAsPinned the pin value to be set
 * @param actionSource the action source
 */
export default action('pinItems', datapoints.pinItemsDatapoint)(function pinItems(rowKeys, tableView, shouldMarkAsPinned, actionSource) {
    undoActions.clearLastUndoableAction();
    // Get all the row keys to update by checking if the existing pinned value is the same as the one to set
    var filteredRowKeys = filterRowKeysByPinValue(rowKeys, tableView, shouldMarkAsPinned);
    // Get the dedupped item ids to update, as multiple rowKeys could map to the same rowId
    var itemIdStringsToUpdate = getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    if (itemIdStringsToUpdate.length == 0) {
        // No need to send out the service call
        return Promise.resolve();
    }
    markItemsAsPinnedStoreUpdate(filteredRowKeys, tableView.id, shouldMarkAsPinned);
    // Make service request
    // Task 658: Reload client state when pin action fails on the server
    markItemsAsPinnedService(itemIdStringsToUpdate, shouldMarkAsPinned);
    // return the promise to catch the end to end time of pinItemsDatapoint
    return Promise.resolve();
});
/**
 * Filter the row keys to update by the pin value
 * @param rowKeys to pin/unpin
 * @param tableView that the rows belong to
 * @param shouldMarkAsPinned isPinned value to be set
 */
function filterRowKeysByPinValue(rowKeys, tableView, shouldMarkAsPinned) {
    var filteredRowKeys = [];
    rowKeys.forEach(function (rowKey) {
        if ((MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) && !shouldMarkAsPinned) ||
            (!MailRowDataPropertyGetter.getIsPinned(rowKey, tableView) && shouldMarkAsPinned)) {
            filteredRowKeys.push(rowKey);
        }
    });
    return filteredRowKeys;
}
//# sourceMappingURL=pinItems.js.map